enum ActivityStatus {
  Scheduled = 0,
  Started = 1,
  Finished = 2,
  Uncleaned = 3,
  Cancelled = 4,
  Completed = 5,
}

export default ActivityStatus;
